/**
 * Vuex getters for the "siwfauth" module.
 *
 * Thin state accessor exposing the stored SIWF data as-is.
 */
export default {
  getSiwfData: state => state.siwfData,
};
